import React, { ReactElement } from 'react';
import {
  Button, Col, Row, Text,
} from 'idsk-react-components';
import './pravoEuDetailRow.scss';
import PravnyZaklad from '../../model/PravnyZaklad';

interface Props {
  header: string;
  data?: string | number | PravnyZaklad[] | string[];
}

const renderPravnyZaklad = (pravnyZaklad: PravnyZaklad): ReactElement => pravnyZaklad.url && (
  <Button
    className="detail-row__pravny-zaklad"
    buttonStyle="link"
    size="small"
    onClick={() => {
      window.parent.postMessage({
        type: 'iframe-to-parent-absolute-url',
        route: pravnyZaklad?.url,
        newTab: true,
      }, '*');
    }}
  >{pravnyZaklad.nazov}
  </Button>
);

const renderStringValue = (text: string): ReactElement => (
  <>
    <Text
      type="span"
    >{text}
    </Text><br />
  </>
);

const PravoEuDetailRow = ({
  header,
  data,
}: Props): ReactElement => {
  if (data === null || data === undefined) {
    return <></>;
  }

  const ulClass = (typeof data[0] === 'object' || typeof data[0] === 'string')
    ? 'li-margin-top li-margin-bottom'
    : 'li-margin-bottom';

  if (Array.isArray(data) && data.length > 0) {
    if (data.length > 1) {
      return (
        <Row className="pravo-eu-detail-row">
          <Col width="one-third">
            <Text type="span" className="information-header">{header}</Text>
          </Col>
          <Col width="two-thirds">
            <ul className={ulClass}>
              {data.map((arrayValue: string | PravnyZaklad) => (
                typeof arrayValue === 'object' ? (
                  <li key={arrayValue.nazov} className="li-link">
                    {renderPravnyZaklad(arrayValue)}
                  </li>
                ) : <li key={arrayValue}>{renderStringValue(arrayValue)}</li>
              ))}
            </ul>
          </Col>
        </Row>
      );
    }
    return (
      <Row className="pravo-eu-detail-row">
        <Col width="one-third">
          <Text type="span" className="information-header">{header}</Text>
        </Col>
        <Col width="two-thirds">
          {typeof data[0] === 'object' ? (
            renderPravnyZaklad(data[0] as PravnyZaklad)
          ) : (renderStringValue(data[0]))}
        </Col>
      </Row>
    );
  }

  if (!data || (Array.isArray(data) && data.length === 0) || (typeof data === 'string' && data.trim() === '')) {
    return <></>;
  }

  return (
    <Row className="pravo-eu-detail-row">
      <Col width="one-third">
        <Text type="span" className="information-header">{header}</Text>
      </Col>
      <Col width="two-thirds">
        <Text type="p" className="pravo-eu-detail-row-text">{data}</Text>
      </Col>
    </Row>
  );
};

export default PravoEuDetailRow;
